import React from 'react';
import { useCountUp } from 'shared/hooks/use-count-up';

export interface UDAnimatedNumberProps {
  value: number;
  /** Как печатать число (разряды, единицы). По умолчанию — как есть. Звать с итоговым и с промежуточным значением. */
  format?: (value: number) => string;
  durationMs?: number;
  /** Знаков после запятой у промежуточных значений; по умолчанию — 0 у целого и 2 у дробного. */
  precision?: number;
}

const defaultFormat = (value: number) => String(value);

/**
 * Число, которое при показе набегает от нуля до `value` (`useCountUp`).
 *
 * Цифры одной ширины (`tabular-nums`), чтобы ряд не дрожал на ходу. Скринридеру отдаётся только итог:
 * бегущее число скрыто от него, иначе он зачитал бы промежуточные значения.
 */
const UDAnimatedNumber = ({ value, format = defaultFormat, durationMs, precision }: UDAnimatedNumberProps) => {
  const animated = useCountUp(value, { durationMs, precision: precision ?? (Number.isInteger(value) ? 0 : 2) });

  return (
    <>
      <span aria-hidden className="tabular-nums" data-testid="animated-number-visual">
        {format(animated)}
      </span>
      <span className="sr-only">{format(value)}</span>
    </>
  );
};

export default React.memo(UDAnimatedNumber);
